<template>
  <v-container>
    <landing-create :content="createPermissionContent"></landing-create>
    <permission-form
      v-if="permission"
      :isLoading="isLoading"
      :permission="permission"
      :onSubmit="onSubmit">
    </permission-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import PermissionForm from './PermissionForm.vue';
import services from '../../../services';

const { controlPanelRegistry } = services;
const { permissionService } = controlPanelRegistry;

export default {
  name: 'PermissionCreate',
  components: {
    PermissionForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    createPermissionContent: {
      pageTitle: 'Update Permission',
      enableBackButton: true,
    },
    permission: null,
  }),
  async created() {
    const { id } = this.$route.params;
    const permission = await permissionService.getOne({ id });
    this.permission = permission;
  },
  methods: {
    async onSubmit(dataChange) {
      const data = Object.assign(this.permission || {}, dataChange);

      this.isLoading = true;
      try {
        await permissionService.update({ permission: data });

        this.$snackbar.show({
          showClose: Boolean,
          text: 'Successfully updated permission!',
          timeout: 4000,
          closeColor: 'white',
          color: 'green',
        });
        this.$router.push({ name: 'permission.list' });
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
  },
};
</script>
